export default __webpack_public_path__ + "static/media/img (2).284fc873.jpg";